import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class ForestWhispering2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FOREST_WHISPERING2;
}

export default ForestWhispering2PoiTileEntity;
